import * as React from 'react';
import styled from '@emotion/styled';
import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { localStorageAvailable } from '@utils/localStorage';
import ShowCase from 'aquilla/core/molecules/ShowCase';
import pushRoute from '@utils/pushRoute';
import NewBatchCard from '@cont/EnrolledCourse/NewBatchCard';
import BatchNudge from './BatchNudge';
import { Spacings } from '../../../styleConstants';

interface IBatchTypeBlock {
  goalUID: string;
  data: any;
  isLoading: boolean;
  refetchBatchData: any;
}

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_5B};
  grid-column: span 18;
  margin-bottom: 57px;
  grid-row-gap: ${Spacings.SPACING_4B};
  height: fit-content;
`;

const isNudgeVisible = (results) =>
  results.length > 1 &&
  Number(localStorageAvailable() && localStorage.getItem('batchNudgeCount')) <
    3;

const BatchTypeBlock: React.FC<IBatchTypeBlock> = ({
  goalUID,
  data = {},
  isLoading,
  refetchBatchData
}) => {
  const { results = [], count } = data;
  const batchRef = useRef();
  const { query = {} } = useRouter();
  const { showBatches, goalSlug } = query;

  const [showNudge, setShowNudge] = useState(isNudgeVisible(results));
  const hideNudge = () => {
    if (localStorageAvailable()) {
      let count = Number(localStorage.getItem('batchNudgeCount'));
      count += 1;
      localStorage.setItem('batchNudgeCount', `${count}`);
    }
    setShowNudge(false);
  };

  useEffect(() => {
    if (!isLoading) {
      refetchBatchData();
      setShowNudge(isNudgeVisible(results));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShowNudge(isNudgeVisible(results));
  }, [results]);

  useEffect(() => {
    if (
      !isLoading &&
      results.length &&
      batchRef.current &&
      showBatches === 'true'
    ) {
      window.scrollTo({
        top:
          // @ts-ignore
          batchRef.current?.offsetTop - 120,
        behavior: 'smooth'
      });
    }
  }, [batchRef, showBatches, isLoading, results]);

  if (isLoading || !results.length) return null;

  const handleSeeAll = () => {
    const route = {
      href: '/goal/[goalSlug]/[goalUID]/enrolled/batches',
      as: `/goal/${goalSlug}/${goalUID}/enrolled/batches`
    };
    pushRoute(route.href, route.as);
  };

  // @ts-ignore
  return (
    <Wrapper ref={batchRef}>
      {showNudge ? (
        <BatchNudge batchCount={count} hideNudge={hideNudge} />
      ) : null}
      <ShowCase
        title="Batches"
        itemsPerSlide={3}
        onSeeAll={results.length > 3 ? handleSeeAll : null}
      >
        {results.slice(0, 3).map((batch, _index) => (
          <NewBatchCard key={batch.uid} batch={batch} />
        ))}
      </ShowCase>
    </Wrapper>
  );
};

export default BatchTypeBlock;
